import styled, { css } from 'styled-components';
import { pxToRem } from '@anwb/style-utilities';
const INDICATOR_ELEMENT_HEIGHT_INITIAL = 30;
const SMALL_BORDER_SIZE = 1;
const SHADOW_SIZE = 2;
/**
 * Gallery indicator
 */
export const galleryIndicatorElementStyles = ({ theme, $isActive, }) => css `
	height: ${pxToRem(INDICATOR_ELEMENT_HEIGHT_INITIAL)};
	padding: ${pxToRem(theme.spacing['200'])} ${pxToRem(theme.spacing['200'])}
		${pxToRem(theme.spacing['200'])} 0;
	border: ${pxToRem(SMALL_BORDER_SIZE)} solid ${theme.colors.blanc.bgGalleryIndicator};
	background-color: ${theme.colors.blanc.bgGalleryIndicator};
	font-size: 0;
	position: relative;
	cursor: pointer;
	display: inline-block;

	& > span {
		width: ${pxToRem(theme.spacing['200'])};
		height: ${pxToRem(theme.spacing['200'])};
		padding: 0;
		border-radius: ${pxToRem(theme.borderRadius.rounded)};
		background-color: ${theme.colors.light.indicatorDefault};
		display: inline-block;
	}

	&:hover > span {
		background-color: ${theme.colors.highlight.indicatorHover};
	}

	&:first-of-type {
		border-top-left-radius: ${pxToRem(theme.borderRadius.s)};
		margin-right: -${pxToRem(SMALL_BORDER_SIZE)};
		padding-left: ${pxToRem(theme.spacing['200'])};

		&::before {
			position: absolute;
			bottom: -${pxToRem(SMALL_BORDER_SIZE)};
			width: ${pxToRem(theme.spacing['200'])};
			height: ${pxToRem(theme.spacing['200'])};
			content: ' ';
			left: -${pxToRem(Number(theme.spacing['200']) - SMALL_BORDER_SIZE)};
			border: ${pxToRem(SMALL_BORDER_SIZE)} solid ${theme.colors.blanc.bgGalleryIndicator};
			border-bottom-right-radius: ${pxToRem(theme.borderRadius.m)};
			border-width: 0 ${pxToRem(SMALL_BORDER_SIZE)} ${pxToRem(SMALL_BORDER_SIZE)} 0;
			box-shadow: ${pxToRem(SHADOW_SIZE)} ${pxToRem(SHADOW_SIZE)} 0
				${theme.colors.blanc.bgGalleryIndicator};
		}
	}

	&:last-of-type {
		border-top-right-radius: ${pxToRem(theme.borderRadius.s)};
		margin-left: -${pxToRem(SMALL_BORDER_SIZE)};

		&::before {
			position: absolute;
			bottom: -${pxToRem(SMALL_BORDER_SIZE)};
			width: ${pxToRem(theme.spacing['200'])};
			height: ${pxToRem(theme.spacing['200'])};
			content: ' ';
			right: -${pxToRem(Number(theme.spacing['200']) - SMALL_BORDER_SIZE)};
			border: ${pxToRem(SMALL_BORDER_SIZE)} solid ${theme.colors.blanc.bgGalleryIndicator};
			border-bottom-left-radius: ${pxToRem(theme.borderRadius.m)};
			border-width: 0 0 ${pxToRem(SMALL_BORDER_SIZE)} ${pxToRem(SMALL_BORDER_SIZE)};
			box-shadow: -${pxToRem(SHADOW_SIZE)} ${pxToRem(SHADOW_SIZE)} 0 ${theme.colors.blanc.bgGalleryIndicator};
		}
	}

	${$isActive &&
    css `
		> span {
			background-color: ${theme.colors.action.indicatorActive};
		}
	`}
`;
export const GalleryIndicatorElement = styled.label `
	${galleryIndicatorElementStyles}
`;
//# sourceMappingURL=gallery-indicator.styled.js.map